import { useInstance } from 'intact-vue-next';
import { useDraggable } from '../../hooks/useDraggable';
export function useDrag() {
  var instance = useInstance();
  var mousedown = false;
  var mousemove = false;
  var x;
  var _useDraggable = useDraggable({
      onStart: function onStart(e) {
        mousedown = true;
        x = e.clientX;
        instance.get('onStart')();
      },
      onMove: function onMove(e) {
        mousemove = true;
        var _instance$get = instance.get(),
          value = _instance$get.value,
          max = _instance$get.max;
        var deltaX = e.clientX - x;
        var newValue = value + deltaX;
        x = e.clientX;
        instance.set('value', Math.min(max, Math.max(0, newValue)));
      },
      onEnd: function onEnd(e) {
        if (instance.$unmounted) return;
        if (mousedown && !mousemove) instance.trigger('click');
        mousedown = false;
        mousemove = false;
        instance.get('onEnd')();
      }
    }),
    start = _useDraggable.start;
  return {
    start: start
  };
}